import { WhatsAppCTAButtons } from './WhatsAppCTA';

const heroImg = '/imagem/banner_alarme_google_optimized.webp';

export default function PageBanner() {
  return (
    <section className="relative min-h-[50vh] md:min-h-[55vh] flex items-center overflow-hidden bg-[#F8F9FA] shrink-0">
      <div className="absolute inset-0">
        <img
          src={heroImg}
          alt="Blog Eletrônica 2000"
          width={1400}
          height={500}
          fetchPriority="high"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" />
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-12 py-16 md:py-20 pt-28 md:pt-32">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block text-xs md:text-sm font-semibold tracking-widest text-emerald-400 uppercase mb-4">
            Blog Especializado
          </span>
          <h1 className="text-3xl md:text-5xl font-extrabold text-white leading-tight">
            Segurança Eletrônica e{' '}
            <span className="text-emerald-400">Automação</span>
          </h1>
          <p className="mt-5 text-base md:text-lg text-white/80 leading-relaxed max-w-xl mx-auto">
            Dicas, guias e novidades sobre câmeras, alarmes, cerca elétrica,
            portões e segurança rural para chácaras e fazendas. Conteúdo exclusivo
            da Eletrônica 2000 – Campo Mourão desde 1993.
          </p>
          <div className="flex items-center justify-center mt-8">
            <WhatsAppCTAButtons size="lg" layout="row-responsive" />
          </div>
        </div>
      </div>
    </section>
  );
}
